import { styled } from "@vitality-ds/system";
import BaseDialogContentStyles from "./styles/BaseDialogContent.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseDialogContent = styled("div", BaseDialogContentStyles);